import { isBrowser } from '@utils/is-browser'
import { useEffect } from 'react'

export const useEffectOverlay = (isOpen: boolean) => {
  useEffect(() => {
    if (isBrowser) {
      const body = document.querySelector('body')
      const gatsby = document.querySelector('#___gatsby')
      if (isOpen) {
        body.classList.add('overflow-hidden')
        gatsby.setAttribute('aria-hidden', String(true))
      } else {
        body.classList.remove('overflow-hidden')
        gatsby.setAttribute('aria-hidden', String(false))
      }

      return () => {
        body.classList.remove('overflow-hidden')
        gatsby.setAttribute('aria-hidden', String(false))
      }
    }
  }, [isOpen])
}
